import createPseudoHook from '../createPseudoHook';
export const useActive = createPseudoHook({
    events: ['mousedown', 'mouseup'],
});
export const useFocus = createPseudoHook({
    events: ['focus', 'blur'],
});
export const useHover = createPseudoHook({
    events: ['mouseenter', 'mouseleave'],
});
export { default as useDimensions } from './useDimensions';
export { default as useScaledSize } from './useScaledSize';
export { default as useLayout } from './useLayout';
export { default as useREM } from './useREM';
//# sourceMappingURL=index.js.map